
export function listToMap(list, key = '_id') {
  return list?.reduce((acc, obj) => {
    acc[obj[key]] = obj;
    return acc;
  }, {}) ?? {};
}
